<template>
  <div class="link-item">
    <p class="link-title">{{ linkData.title }}</p>
    <ul class="linklist">
        <li v-for="(item,index) in linkData.children" :key="index">
          <!-- {{ item.name }} -->

          <a v-if="item.name == 'Blog'" href="https://blog.meshare.com" class="sw-pc">{{item.name}}</a>
          <a v-else-if="item.name == 'Careers'" :href="item.path" class="sw-pc">{{item.name}}</a>
          <router-link v-else :to="item.path" v-html="item.name" class="sw-pc"></router-link>


           <a v-if="item.name == 'Blog'" href="https://blog.meshare.com" class="sw-sm">{{item.name}}</a>
           <a v-else-if="item.name == 'Careers'" :href="item.path" class="sw-sm">{{item.name}}</a>
          <router-link v-else :to="item.path" v-html="item.name" class="sw-sm"></router-link>

        </li>
    </ul>
  </div>
</template>

<script>

import {WOW} from 'wowjs'
export default {
  name: 'LinkList',
  props: {
      linkData: {}
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/css/common.scss';
.link-item{
    .sw-pc{
      display: inherit;
      @media screen and (max-width: $media-max-width) {
        display: none;
      }
    }
    .sw-sm{
      display: none;
      @media screen and (max-width: $media-max-width) {
        display: inherit;
      }
    }
    .link-title{
        color: #ba0c2f;
        font-size: 14px;
        font-family: 'GothamMedium';
        margin-bottom: 25px;
        @media screen and (max-width: $media-max-width) {
          margin-bottom: 10px;
        }
    }
    .linklist{
        display: -webkit-flex;
        display: flex;
        flex-direction: column;
        max-width: 220px;
        @media screen and (max-width: $media-max-width) {
          margin-bottom: 10px;
          max-width: unset;
          padding-bottom: 10px;
          border-bottom: 1px solid #e0e0e0;
        }
        li{
            font-size: 14px;
            color: #000000;
            font-family: 'GothamBook';
            margin: 7px 0;
            @media screen and (max-width: $media-max-width) {
              margin: 8px 0px;
            }
            a{
              color: #000000;
              text-decoration: none;
            }
            &:hover{
              @media screen and (min-width: $media-max-width) {
                a{
                  color: #ba0c2f;
                }
              }
            }
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/modules/footer/linkList.vue